import React, { useState, useEffect, useContext, useRef} from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { AuthContext } from "../../Header/auth - context";
import { useSelector } from 'react-redux';
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';
import CustomDropdown from '../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import handlePrintAcontation from '../Finansije/stranaAkontacije/akontacijaStampa';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import 'primeicons/primeicons.css';

const Blagajna = (props) => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const formRef = useRef(null);
    const toast = useRef(null);
    const trip = useSelector(state => state.trip)
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const [idWorker, setIdWorker] = useState(null)
        const [selectedRowIdAcontation , setSelectedRowIdAcontation] = useState(null);
        const isSelected = (row) => String(getIdAcontation(row)) === String(selectedRowIdAcontation);
        const [valutaOptions, setValutaOptions] = useState(null)
        const [trenutniSaldo, setTrenutniSaldo] = useState([])
        const [vrstaTransakcijeDB, setVrstaTransakcijeDB] = useState([])
        const [vozaciNaPutuDB, setVozaciNaPutuDB] = useState(null)
        const [izabran, setIzabran] = useState(false)
        const [idAcontation, setIdAcontation] = useState(null)
        const [popuni, setPopuni] = useState(false)

        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);

    const [formSubmitted, setFormSubmitted] = useState(false);
        // sumarni obračun po vozaču na ovom putnom nalogu, sve u EUR
        const [sumaEUR, setSumaEUR] = useState([]);

        const getIdAcontation = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

        const [formDataAcontacion, setFormDataAcontacion] = useState({
          brojAkontacije: '',
          id_vrsta_transakcije: null,
          datumPredaje: null,
          Iznos: null,
          Valuta: null,
          Napomena: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali akontaciju da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/FillInAcontationData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                         
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka akontacije!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataAcontacion({
        brojAkontacije: apiData[0].Broj || '',
        id_vrsta_transakcije: apiData[0].id_vrsta_transakcije || null,
        datumPredaje: apiData[0].datumPredaje ? new Date(apiData[0].datumPredaje) : null,
        Iznos: apiData[0].Iznos || null,
        Valuta: apiData[0].id_valuta || null,
        Napomena: apiData[0].Napomena || '',
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                    trip: trip
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setValutaOptions(parsedData.ValuteDB)
                                setTrenutniSaldo(parsedData.TrenutniStatus)
                                setVrstaTransakcijeDB(parsedData.VrstaTrabsakcijeDB)

                                // if(data){
                                //    (data) 
                                // }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted, idAcontation])

        useEffect(()=>{
        if(trip) {
  let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                putniNalog: trip
                            }),
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/WorkLog", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setVozaciNaPutuDB(parsedData.DriversFromTrip)

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
            if(!idWorker) {
                fillDataTableForWorker(null); ucitajSumuEUR();
            }
        } else {
            if(idWorker) {
                setIdWorker(null)
            }
            if(izabran) {
                setIzabran(false)
            }
            if(popuni) {
                setPopuni(false)
            }
        }

    },[formSubmitted, trip])

const resetData = ()=> {
    setFormDataAcontacion({
        brojAkontacije: '',
        id_vrsta_transakcije: null,
        datumPredaje: null,
        Iznos: null,
        Valuta: null,
        Napomena: ''
    })
}
const handleDeleteFuncAcontation = () => {
       
            confirmDialog({
            message: "Želite obrisati akontaciju?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async (id) => {
 
  let idValue;
  if(idAcontation == null && !isNaN(Number(id)))
    idValue = id
  else
    idValue = idAcontation
  if (Number(idValue)) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idValue
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/DeleteAcontacion", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešna brisanje akontacije!",
                life: 3000,
                });
                resetData()
                setIdAcontation(null)
                setSelectedRowIdAcontation(null)
            fillDataTableForWorker(null); ucitajSumuEUR();
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali akontaciju za štampu!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 

    const handlePrintFuncAcontation = (id) => {
       
            confirmDialog({
            message: "Unos putnog naloga je završen. Štampa?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: ()=> acceptPrint(id),
            reject: rejectPrint,
            });

    };
 const acceptPrint = async (id) => {
  let idValue;
  if(idAcontation == null && !isNaN(Number(id)))
    idValue = id
  else
    idValue = idAcontation
  if (Number(idValue)) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: Number(idValue)
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/printAcontation", requestOptions)
          .then(handleErrors)
          .then((data) => {
            if(data){
              handlePrintAcontation(data)
            } 
    
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali akontaciju za štampu!",
            life: 3000,
            });
  }
   

  };
  const rejectPrint = () => {
    console.log("Odbijeno štampanje podataka!");
  };  

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {

              if (!idWorker) {
                  toast.current.show({
                      severity: "warn",
                      summary: "Upozorenje!",
                      detail: "Niste izabrali vozača!",
                      life: 3000,
                  });
                  return;
              }

              const val = trenutniSaldo.filter((x)=> x.IdValute == formDataAcontacion.Valuta)
               //doraditi izabran
               if (idAcontation) {

                let col = tableData.filter((x)=> x.Izaberi == idAcontation)
                
                let valuta = valutaOptions.filter((x)=> x.value == formDataAcontacion.Valuta)
                let suma;
        
                if(formDataAcontacion.Iznos > col[0].Iznos && valuta[0].label == col[0].Valuta) {
                  suma = formDataAcontacion.Iznos - col[0].Iznos
                    if(val[0].SumaKorigovana < suma && formDataAcontacion.id_vrsta_transakcije == 221) {
                      toast.current.show({
                                severity: "warn",
                                summary: "Nije moguće ažurirati transakciju jer nema dovoljno novca u kasi za " + val[0].Valuta + "!",
                                life: 3000,
                                });
                                return
                    }
                }
              } else {
                if (val[0].SumaKorigovana < formDataAcontacion.Iznos && formDataAcontacion.id_vrsta_transakcije == 221){
                  toast.current.show({
                                severity: "warn",
                                summary: "Nije moguće uneti transakciju jer nema dovoljno novca u kasi za " + val[0].Valuta + "!",
                                life: 3000,
                                });
                                return
                } 
              }
              //DATA
                  const hasAnyValueAcontation = Object.values(formDataAcontacion).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataAcontacion,
                        trip,
                        datumPredaje: toUtcIso(formDataAcontacion.datumPredaje)
                        };

                  if(izabran && idWorker && idAcontation){
                 if(hasAnyValueAcontation){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idAcontation),
                                id_zaposleni: idWorker.id,
                                formDataAcontacion: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/UpdateAcontation", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima akontacije.' && data[0].message != 'Uspešna izmena!'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima akontacije.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka akontacije!",
                                life: 3000,
                                });
                               
                               }
                                setFormSubmitted(false)
                                
                                fillDataTableForWorker(null); ucitajSumuEUR();
                                setIdAcontation(null)
                                setSelectedRowIdAcontation(null)
                                if(data[0].ID) {
                                    handlePrintFuncAcontation(data[0].ID)
                                }
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke akontacije!",
                        life: 3000,
                    });
                }
           
           
            } else {
                  if(hasAnyValueAcontation){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                id_zaposleni: idWorker.id,
                                  formDataAcontacion: payload
                              }),
                          };
                         
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/InsertAcontacion", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                    
                                  if(data.message === 'Nedostaju obavezna polja za unos akontacije.'){
                                      toast.current.show({
                                      severity: "error",
                                      summary: "Error",
                                      detail: data.message,
                                      life: 3000,
                                      });
                                      return
                                  } 
                                  
                                  if(data[0].ID) {
                                    handlePrintFuncAcontation(data[0].ID)
                                }
                                  resetData()
                                  setFormSubmitted(false)
                                  fillDataTableForWorker(null); ucitajSumuEUR();
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka akontacije!",
                                  life: 3000,
                                  });

                                
                              //ubaciti deo da se forma ID za dalji unos
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke akontacije za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataAcontacion) {
        setFormDataAcontacion(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  /* Sumarni obračun po vozaču za ceo putni nalog, u EUR.
     Preračun po kursu NBS-a na dan transakcije radi procedura — ovde se
     iznosi samo prikazuju. */
  const ucitajSumuEUR = async () => {
    if (!trip) { setSumaEUR([]); return; }
    try {
      const r = await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetAcontacionSumaEUR", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
        body: JSON.stringify({ trip }),
      });
      const data = r.ok ? await r.json() : [];
      setSumaEUR(Array.isArray(data) ? data : []);
    } catch {
      setSumaEUR([]);
    }
  };

  const fillDataTableForWorker = async (id) => {

           let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_zaposleni: id,
                                  trip
                              }),
                          };
                  
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetAcontacion", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                             
                                    setTableData(data)
                      
                                
                                  if (data && data.length > 0) {
                                                const columns = Object.keys(data[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));

                                                setAllColumns(columns);
                                                  const originalOrder = Object.keys(data[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                            })

}

// const selectIdWorkerFUNC = (e) => {

//     if(e.target.value == undefined) {
//         setIzabran(false);
//         setTableData(null)
//         resetData()
//     } else {
//         setIzabran(true);
//     }  

//     setIdWorker(e.target.value);
//     fillDataTableForWorker(e.target.value)
//     setPopuni(false)
//     };

//     const handleClickWorker = () => {
//        if (idWorker) {  // resetuj samo ako ima vrednost
//         setIdWorker(null);
//         setIzabran(false);
//         setTableData(null)
//         setSelectedRowIdAcontation(null)
//         setPopuni(false);
//         resetData();
//         setIdAcontation(null)
//     }
// }

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Akontacija');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Klijenti - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                  <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                  {formDataAcontacion.id_vrsta_transakcije == 221 && <Button type="button" icon="pi pi-print" severity="secondary" rounded onClick={handlePrintFuncAcontation} data-pr-tooltip="Print" />}
                  {selectedRowIdAcontation && <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncAcontation} data-pr-tooltip="Obriši" />}
              </div>
              <input
                  type="search"
                  onInput={(e) => setGlobalFilter(e.target.value)}
                  placeholder={t('nova.phPretraga')}
                  className="p-inputtext p-component"
                  style={{ width: '30%' }}
              />
          </div>
      );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseAcontation = (rowData) => {
      const id = getIdAcontation(rowData);

    setSelectedRowIdAcontation((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if(next) {
       setIdAcontation(next)
      popuniRedove(id) 
      }
      else {
      setIdAcontation(null)
      resetData()
      }

    return next;
  });
 
  
}

     const previewBodyTemplateWork = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseAcontation(rowData)}
              />
            
        </div>
      );
    };

const selectIdDriverFUNC = (e) => {
    const worker = e.target.value;

    if(worker == undefined) {
        setIzabran(false);
        resetData()
    } else {
        setIzabran(true);
    }
    setIdWorker(worker || null);
    /* Izbor vozača služi SAMO popunjavanju forme — tabela i dalje prikazuje sve
       akontacije putnog naloga i ne osvežava se ovde. */
    setPopuni(false)
    };

const handleClickWorkLog = () => {
       if (idWorker) {  // resetuj samo ako ima vrednost
        setIdWorker(null);
        setIzabran(false);
        setSelectedRowIdAcontation(null)
        setPopuni(false);
        resetData();
        setIdAcontation(null)
        fillDataTableForWorker(null); ucitajSumuEUR();
    }
}

    return (
        <div className="p-fluid grid formUnosZap">
            <Toast ref={toast} />
            <div style={{marginLeft:"1%"}}>
                <div style={{display:'flex'}}><p style={{marginRight: '1%',marginBottom: '0', display:'flex', justifyContent: 'center', alignItems:'center'}}>{t('ture.trenutniSaldo')}:</p>{trenutniSaldo.map((item, i) => {
                                return (
                                <div key={i} style={{display:'flex', justifyContent: 'center', alignItems:'center', border: '1px solid rgb(224, 221, 221)', padding:'10px'}} >
                                    <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}} className={item.SumaKorigovana < 10 ? 'colorRed' : null}> <strong>{item.SumaKorigovana}</strong></p>
                                    <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}}><strong>[{item.Valuta}]</strong></p>
                                </div>
                                );
                            })}
                </div>
            </div>
            <div className="col-12" style={{display:'flex',alignItems: "center", paddingLeft: '2%',width: '100%'}}>
                     
                                <div style={{width: '60%', margin: '2%'}}>
                                    <div style={{display:'flex',alignItems: "center"}}>
                                        <h4>{t('ture.izborVozaca')}:</h4>
                                    
                                        <CustomDropdown
                                           style={{ width: "30.65%", margin: "0 0 0 2%" }}
                                            options={vozaciNaPutuDB || []}
                                            value={idWorker}
                                            placeholder={t('ture.phVozaca')} 
                                            optionLabel="label"
                                            onChange={selectIdDriverFUNC}
                                            onFocus={handleClickWorkLog} />
                                    </div>
                                                   
                                </div>
                         
                        </div>
            <div className='col-12'>
                           <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                                      <div className='blagajnaDashboard' style={{display:'flex', gap:'1rem', alignItems:'flex-start', flexWrap:'wrap'}}>
                                         <div style={{flex:'1 1 35%', minWidth:'280px'}}>
                                         <Card>
                                        <div className="gridLicni">
                                          <div className="col-12 md:col-6">
                                                                          <label htmlFor="brojAkontacije">{t('nova.broj')}:</label>
                                                                          <InputText
                                                                              id="brojAkontacije" disabled 
                                                                              name="brojAkontacije" value={formDataAcontacion.brojAkontacije} inputStyle={{backgroundColor: '#efefef'}} 
                                                                          />
                                                                          
                                                                      </div>
                                            <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="Valuta">{t('ture.vrstaTransakcije')}:</label>
                                                      <Dropdown 
                                                            id="id_vrsta_transakcije" 
                                                            name="id_vrsta_transakcije" 
                                                            required
                                                            invalid={invalidControl(formDataAcontacion.id_vrsta_transakcije)}
                                                            value={formDataAcontacion.id_vrsta_transakcije} 
                                                            options={vrstaTransakcijeDB || []} 
                                                            onChange={handleChange}
                                                            placeholder={t('ture.phTransakciju')}
                                                        />
                                          </div>
                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="Valuta">{t('ture.datumTransakcije')}:</label>
                                                        <Calendar 
                                                            id="datumPredaje"
                                                            name="datumPredaje"
                                                            required
                                                            invalid={invalidControl(formDataAcontacion.datumPredaje)} 
                                                            value={formDataAcontacion.datumPredaje} 
                                                            onChange={handleChange}
                                                            showIcon 
                                                            mask="99.99.9999"
                                                            dateFormat="dd.mm.yy" 
                                                            />
                                          </div>
                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="Iznos">{t('nova.iznos')}:</label>
                                             <InputNumber 
                                                    id="Iznos" 
                                                    name="Iznos" 
                                                    required
                                                    invalid={invalidControl(formDataAcontacion.Iznos)}
                                                    value={formDataAcontacion.Iznos} 
                                                    onValueChange={handleChange}
                                                    minFractionDigits={2}
                                                    maxFractionDigits={2}
                                                    />
                                          </div>
            
                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="Valuta">{t('nova.valuta')}:</label>
                                                      <Dropdown 
                                                                                id="Valuta" 
                                                                                name="Valuta" 
                                                                                required={formDataAcontacion.Iznos == null ? false : true}
                                                                                invalid={formDataAcontacion.Iznos != null ? invalidControl(formDataAcontacion.Valuta) : null}
                                                                                value={formDataAcontacion.Valuta} 
                                                                                options={valutaOptions || []} 
                                                                                onChange={handleChange}
                                                                                placeholder={t('nova.phValutu')}
                                                                            />
                                          </div>
                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                                <label htmlFor="Napomena">{t('nova.napomena')}:</label>
                                                <InputText 
                                                id="Napomena" 
                                                name="Napomena" 
                                                value={formDataAcontacion.Napomena} 
                                                onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="formUnosZap buttonUnosZap">
                                          <button type="submit" onClick={handleFormSubmit} style={{ minWidth: 'fit-content', marginTop: '2%' }} className="btn btn-success">
                                            {idAcontation ? "SAČUVAJ" : "UNOS"}
                                          </button>
                                        </div>

                                        {/* Sumarni obračun po vozaču na ovom putnom nalogu, sve svedeno na EUR.
                                            Preračun ide po srednjem kursu NBS-a NA DAN transakcije. */}
                                        {sumaEUR.length > 0 && (
                                          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem', fontSize: '0.9rem' }}>
                                            <thead>
                                              <tr>
                                                <th style={{ border: '1px solid #ccc', padding: '6px 10px', background: '#f0f0f0', textAlign: 'left', fontWeight: 700 }}>{t('ture.vozac')}</th>
                                                <th style={{ border: '1px solid #ccc', padding: '6px 10px', background: '#f0f0f0', textAlign: 'right', fontWeight: 700 }}>{t('ture.izlazEUR')}</th>
                                                <th style={{ border: '1px solid #ccc', padding: '6px 10px', background: '#f0f0f0', textAlign: 'right', fontWeight: 700 }}>{t('ture.ulazEUR')}</th>
                                                <th style={{ border: '1px solid #ccc', padding: '6px 10px', background: '#f0f0f0', textAlign: 'right', fontWeight: 700 }}>{t('ture.saldoEUR')}</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {sumaEUR.map(red => (
                                                <tr key={red.id_zaposleni}>
                                                  <td style={{ border: '1px solid #ccc', padding: '5px 10px' }}>
                                                    {red.Zaposleni}
                                                    {red.BezKursa > 0 && (
                                                      <span title={t('ture.bezKursaOpis')} style={{ marginLeft: 6, color: '#b26a00', fontWeight: 600 }}>
                                                        ({red.BezKursa} {t('ture.bezKursa')})
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td style={{ border: '1px solid #ccc', padding: '5px 10px', textAlign: 'right' }}>{Number(red.IzlazEUR || 0).toFixed(2)} €</td>
                                                  <td style={{ border: '1px solid #ccc', padding: '5px 10px', textAlign: 'right' }}>{Number(red.UlazEUR || 0).toFixed(2)} €</td>
                                                  <td style={{ border: '1px solid #ccc', padding: '5px 10px', textAlign: 'right', fontWeight: 600, color: Number(red.SaldoEUR) < 0 ? '#d32f2f' : undefined }}>
                                                    {Number(red.SaldoEUR || 0).toFixed(2)} €
                                                  </td>
                                                </tr>
                                              ))}
                                              {sumaEUR.length > 1 && (
                                                <tr>
                                                  <td style={{ border: '1px solid #ccc', padding: '5px 10px', fontWeight: 700, background: '#fafafa' }}>{t('ture.ukupno')}</td>
                                                  {['IzlazEUR', 'UlazEUR', 'SaldoEUR'].map(polje => (
                                                    <td key={polje} style={{ border: '1px solid #ccc', padding: '5px 10px', textAlign: 'right', fontWeight: 700, background: '#fafafa' }}>
                                                      {sumaEUR.reduce((zbir, r) => zbir + Number(r[polje] || 0), 0).toFixed(2)} €
                                                    </td>
                                                  ))}
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        )}
                                      </Card>
                                         </div>
                                         <div style={{flex:'0 0 50%', minWidth:'300px'}}>
                                      <Card>
                                           <Tooltip target=".export-buttons>button" position="bottom" />
                                               <DataTable
                                                      value={tableData || []}
                                                      paginator
                                                      rows={10}
                                                      first={first}
                                                      globalFilter={globalFilter}
                                                      onPage={(e) => setFirst(e.first)}
                                                      scrollable
                                                      header={header}
                                                      scrollHeight="50vh"
                                                      emptyMessage={t('common.noDataTable')}
                                                      resizableColumns
                                                      className="turePregledTable stavke-tabela"
                                                      columnResizeMode="expand"
                                                      rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                                    >
                                                      {selectedColumns.map((colKey) => {
                                                      const colMeta = allColumns.find(col => col.value === colKey);
                                                      return (
                                                        <Column
                                                          key={colKey}
                                                          field={colKey}
                                                          header={colMeta?.label || colKey}
                                                          sortable
                                                          body={(rowData) => {
                                                            if (isButtonColumn(colKey)) {
                                                              return previewBodyTemplateWork(rowData, colKey);
                                                            }
                                                            return rowData[colKey] || '-';
                                                          }}
                                                          style={{ minWidth: '150px'}}
                                                        />
                                                      );
                                                    })}
                                                </DataTable>
                                      </Card>
                                         </div>
                                      </div>
                              </form>
                        </div>
        </div>
    );
};

export default Blagajna;